export class ClmDeclaration {
  LegalDeclaration: number;
  SubmittedAtCourt: number;
  SubmittedAtCity: number;
  CaseNumber: string;
  ClaimAgainst: string;
  JudgmentGivenDate: Date;
  ShortDescriptionDecision: string;
  WrittenDeclaration: number;
  WrittenDeclarationDetails: number;
  IsraeliCitizen: number;
  description: string;

  constructor(data: ClmDeclaration) {

    Object.assign(this, data);
  }
}



// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/models/claim/ClmDeclaration.ts